const Stepper = {
    baseStyle: {
        _focusWithin: {
            borderColor: 'black',
            boxShadow: '0px 0px 8px 0px #BBC1CA',
        },
        _hover: {
            borderColor: 'black',
        },
        alignItems: 'center',
        backgroundColor: 'white',
        borderColor: 'neutral.500',
        borderRadius: 'full',
        borderWidth: '1px',
        display: 'inline-flex',
        h: '40px',
        justifyContent: 'space-between',
        minW: '88px',
        p: '8px',
    },
    defaultProps: {
        size: 'sm',
    },
    sizes: {
        lg: {
            fontSize: 'lg',
            fontWeight: 500,
            h: '48px',
            minW: '112px',
            p: '12px',
        },
        md: {
            fontSize: 'md',
            fontWeight: 500,
            h: '40px',
            minW: '88px',
            p: '8px',
        },
        sm: {
            fontSize: 'sm',
            fontWeight: 500,
            h: '32px',
            minW: '72px',
            p: '4px',
        },
    },
};
export default Stepper;
